import { render } from "./AdministratorMenuLinks.vue?vue&type=template&id=a0f939e6&ts=true"
import script from "./AdministratorMenuLinks.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdministratorMenuLinks.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Navigation/AdministratorMenuLinks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a0f939e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a0f939e6', __exports__)) {
    console.log('reload')
    api.reload('a0f939e6', __exports__)
  }
  
  module.hot.accept("./AdministratorMenuLinks.vue?vue&type=template&id=a0f939e6&ts=true", () => {
    console.log('re-render')
    api.rerender('a0f939e6', render)
  })

}


export default __exports__